import { useEffect, useState } from "react";
import { Modal, Tooltip } from "antd";

import { useNavigate, Link } from "react-router-dom";
import {
	traerDatos,
	traerDatosObjeto,
	HeadersAuth,
	CheckExpiracion,
} from "../funciones_utiles";
import { TablaCompleta } from "../tablas/tabla_simple";
import { FormularioPreCambio } from "../componentes/datosPreCambio";
import { FormularioPassCambio } from "../componentes/cambiarContrasenia";
import moment from "moment";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Header } from "../componentes/header";
import { BtnPrincipal } from "../componentes/btn";
import fondo from "../img/fondo.jpg";
import { DownloadOutlined, ExclamationOutlined } from "@ant-design/icons";
import { EyeOutlined } from "@ant-design/icons";

const MySwal = withReactContent(Swal);

const URI_DATOS_PRE_PEDIDO =
	process.env.REACT_APP_DOMINIO + process.env.REACT_APP_PUERTO + "/login";
const URI_PROTOCOLOS =
	process.env.REACT_APP_DOMINIO + process.env.REACT_APP_PUERTO + "/protocol/";
const URI_DATA =
	process.env.REACT_APP_DOMINIO + process.env.REACT_APP_PUERTO + "/user";

export const ElHome = ({ sesion }) => {
	const [infoProcolos, setInfoProtocolos] = useState([]);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isModalOpenDatos, setIsModalOpenDatos] = useState(false);
	const [datosPreCambio, setDatosPreCambio] = useState({});
	const [refresh, setRefresh] = useState(false); // Estado adicional para refrescar
	const [isHovered, setIsHovered] = useState(false);
  

	const showModal = () => {
		setIsModalOpen(true);
	};
	const showModalDatos = () => {
		setIsModalOpenDatos(true);
	};
	const handleOk = () => {
		setIsModalOpen(false);
	};
	const handleOkDatos = () => {
		setIsModalOpenDatos(false);
	};
	const navigate = useNavigate();
	const logout = async (e) => {
		e.preventDefault();

		MySwal.fire({
			text: "sesion finalizada",
			imageHeight: 65,
			confirmButtonText: "Ok",
		});
		localStorage.removeItem("camulabo_valid_session");
		navigate("/");
		// }
	};
	useEffect(() => {
		if (sesion.pre_cambio) {
			(async () => {
				const datosConsumo = await traerDatosObjeto(URI_DATA);
				// console.log(await traerDatosObjeto(URI))
				setDatosPreCambio(datosConsumo);
			})();
		} else {
			setDatosPreCambio({
				nombre: "",
				apellido: "",
				direccion: "",
				telefono: "",
				email: "",
				obra_social: "",
			});
		}
	}, []);
	const elScroll = { x: 0 };
	const Columns = [
		{
			title: () => (
				<div style={{ textAlign: "center" }}>
					<span style={{ fontSize: "0.8em" }}>{"Fecha protocolo"}</span>
				</div>
			),
			key: "fecha",
			align: "center",
			sorter: (a, b) => a.fecha_documento.localeCompare(b.fecha_documento),
			render: (a) => (
				<div style={{ fontSize: "12px", padding: "2px 4px" }}>
					{moment(`${a.fecha_documento}`, "YYYY-MM-DD").format("DD/MM/YYYY")}
				</div>
			),
		},
		{
			title: () => (
				<div style={{ textAlign: "center" }}>
					<span style={{ fontSize: "0.8em" }}> {"Número de protocolo"}</span>
				</div>
			),
			key: "tipo",
			align: "left",
			sorter: (a, b) => -a.protocolo.localeCompare(b.protocolo),
			render: (a) => (
				<div style={{ fontSize: "14px", padding: "2px 4px" }}>
					{a.protocolo}
				</div>
			),
		},
		{
			title: () => (
				<div style={{ textAlign: "center" }}>
					<span style={{ fontSize: "0.8em" }}> {"Médico solicitante"}</span>
				</div>
			),
			key: "medico_solicitante",
			align: "left",
			sorter: (a, b) =>
				-a.medico_solicitante.localeCompare(b.medico_solicitante),
			render: (a) => (
				<div style={{ fontSize: "12px", padding: "2px 4px" }}>
					{a.medico_solicitante}
				</div>
			),
		},

		{
			title: () => (
				<div style={{ textAlign: "center" }}>
					<span style={{ fontSize: "0.8em" }}>Vista previa</span>
				</div>
			),
			key: "protocolo",
			align: "center",
			render: (dato) => (
				<div className="row">
					<div
						className="col"
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}>
						<button
							className="iconos boton-con-borde"
							onClick={(e) => abrirProtocolo(e, dato.protocolo)}
							style={{
								border: "none",
								background: "none",
								cursor: "pointer",
								padding: "0.5em 0.5em",
								display: "flex",
								alignItems: "center",
								gap: "8px",
							}}>
							<span className="texto-boton">Visualizar</span>
							<EyeOutlined style={{ fontSize: "0.8em" }} />
							<span
								style={{
									fontSize: "0.8em",
								}}>
								{dato.views}
							</span>
						</button>
					</div>
				</div>
			),
		},
		{
			title: () => (
				<div style={{ textAlign: "center" }}>
					<span style={{ fontSize: "0.8em" }}>Descargar</span>
				</div>
			),
			key: "protocolo",
			align: "center",
			render: (dato) => (
				<div className="row">
					<div
						className="col"
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}>
						<button
							className="iconos boton-con-borde"
							onClick={(e) => generarProtocolo(e, dato.protocolo)}
							style={{
								border: "none",
								background: "none",
								cursor: "pointer",
								padding: "0.5em 0.5em",
								display: "flex",
								alignItems: "center",
								gap: "8px",
							}}>
							<span className="texto-boton">Descargar</span>
							<DownloadOutlined style={{ fontSize: "0.8em" }} />
							<span
								style={{
									fontSize: "0.8em",
								}}>
								{dato.downloads}
							</span>
						</button>
					</div>
				</div>
			),
		},
	];
	const ColumnsChica = [
		{
			title: () => (
				<div style={{ textAlign: "center" }}>
					<span style={{ fontSize: "0.8em" }}>{"Fecha protocolo"}</span>
				</div>
			),
			key: "fecha",
			align: "center",
			sorter: (a, b) => a.fecha_documento.localeCompare(b.fecha_documento),
			render: (a) => (
				<div style={{ fontSize: "12px", padding: "2px 4px" }}>
					{moment(`${a.fecha_documento}`, "YYYY-MM-DD").format("DD/MM/YYYY")}
				</div>
			),
		},
		{
			title: () => (
				<div style={{ textAlign: "center" }}>
					<span style={{ fontSize: "0.8em" }}> {"Información"}</span>
				</div>
			),
			key: "tipo",
			align: "left",
			sorter: (a, b) => -a.protocolo.localeCompare(b.protocolo),
			render: (a) => (
				<div style={{ fontSize: "14px", padding: "2px 4px" }}>
					<ul style={{ listStyle: "none" }}>
						<li><b>N°:</b> {a.protocolo}</li>
						<li><b>M. solicitante: </b> {a.medico_solicitante}</li>
					</ul>
				</div>
			),
		},
		{
			title: () => (
				<div style={{ textAlign: "center" }}>
					<span style={{ fontSize: "0.8em" }}></span>
				</div>
			),
			key: "protocolo",
			align: "center",
			render: (dato) => (
				<>
					<div className="row">
						<div
							className="col"
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}>
							<button
								className="iconos boton-con-borde"
								onClick={(e) => abrirProtocolo(e, dato.protocolo)}
								style={{
									border: "none",
									background: "none",
									cursor: "pointer",
									padding: "0.5em 0.5em",
									display: "flex",
									alignItems: "center",
									gap: "8px",
								}}>
								<span className="texto-boton">Visualizar</span>
								<EyeOutlined style={{ fontSize: "0.8em" }} />
								<span
									style={{
										fontSize: "0.8em",
									}}>
									{dato.views}
								</span>
							</button>
						</div>
					</div>
					<div className="row" style={{paddingTop: "0.5em"}}>
						<div
							className="col"
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}>
							<button
								className="iconos boton-con-borde"
								onClick={(e) => generarProtocolo(e, dato.protocolo)}
								style={{
									border: "none",
									background: "none",
									cursor: "pointer",
									padding: "0.5em 0.5em",
									display: "flex",
									alignItems: "center",
									gap: "8px",
								}}>
								<span className="texto-boton">Descargar</span>
								<DownloadOutlined style={{ fontSize: "0.8em" }} />
								<span
									style={{
										fontSize: "0.8em",
									}}>
									{dato.downloads}
								</span>
							</button>
						</div>
					</div>
				</>
			),
		},
	];
  const [currentColumns, setCurrentColumns] = useState(
    window.innerWidth < 768 ? ColumnsChica : Columns
  );
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 650) {
        setCurrentColumns(ColumnsChica);
      } else {
        setCurrentColumns(Columns);
      }
    };

    // Agregar el listener de redimensionamiento
    window.addEventListener("resize", handleResize);

    // Limpieza del listener al desmontar
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [Columns, ColumnsChica]);

	const handleRefresh = () => {
		setRefresh((prev) => !prev); // Cambia el estado para forzar el `useEffect`
	};
	useEffect(() => {
		(async () => {
			const datos = await traerDatos(URI_PROTOCOLOS + sesion.dni);
			// Ordenar por fecha_documento descendente (más nuevos primero)
			const datosOrdenados = Array.isArray(datos)
				? [...datos].sort((a, b) => {
					if (!a.fecha_documento || !b.fecha_documento) return 0;
					return b.fecha_documento.localeCompare(a.fecha_documento);
				})
				: [];
			setInfoProtocolos(datosOrdenados);
		})();
	}, [refresh]);

	const generarProtocolo = async (event, protocolo) => {
		event.preventDefault();
	
		// Detectar si es Safari en iPhone/iPad
		const esSafariIOS =
			/^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
			/iPhone|iPad|iPod/i.test(navigator.userAgent);
	
		try {
			if (esSafariIOS) {
				try {
				  // 🔐 Pedimos la URL segura para Safari iOS
				  const safariUrlResponse = await axios.get(
					`${process.env.REACT_APP_DOMINIO}${process.env.REACT_APP_PUERTO}/protocol/presigned-url/${protocolo}`,
					{ withCredentials: true }
				  );
			  
				  // ⚠️ Mostramos alerta informativa antes de redirigir
				  const result = await MySwal.fire({
					title: "Atención",
					text: "El PDF se abrirá como vista previa. Para descargarlo, tocá el botón de compartir y elegí 'Guardar en Archivos'.",
					icon: "info",
					confirmButtonText: "Entendido",
				  });
			  
				  // ✅ Redirigimos solo si el usuario confirmó
				  if (result.isConfirmed && safariUrlResponse.data?.url) {
					window.location.href = safariUrlResponse.data.url;
				  }
				} catch (error) {
				  console.error("Error al obtener la URL para Safari:", error);
				  MySwal.fire({
					text: "No se pudo preparar el archivo para Safari.",
					icon: "error",
					confirmButtonText: "Ok",
				  });
				}
				return;
			  }
			  
	
			// Para el resto de navegadores: usamos base64 + Blob
			const URI_PDF_RESULTADO = `${process.env.REACT_APP_DOMINIO}${process.env.REACT_APP_PUERTO}/protocol/download/${protocolo}/d`;
			const response = await axios.get(URI_PDF_RESULTADO, {
				withCredentials: true,
				headers: {
					"Content-Type": "application/json",
				},
			});
	
			switch (parseInt(response.data.code)) {
				case 200: {
					const base64PDF = response.data.data;
	
					const byteCharacters = atob(base64PDF);
					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					const byteArray = new Uint8Array(byteNumbers);
					const blob = new Blob([byteArray], { type: "application/pdf" });
					const blobUrl = URL.createObjectURL(blob);
	
					const link = document.createElement("a");
					link.href = blobUrl;
					link.setAttribute("download", `${protocolo}.pdf`);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(blobUrl);
	
					handleRefresh();
					break;
				}
				case 401:
				case 409:
				case 601:
					MySwal.fire({
						text: "Error al generar el protocolo. Por favor, intenta nuevamente.",
						imageHeight: 55,
						icon: "error",
						confirmButtonText: "Ok",
					});
					break;
				case 400:
					MySwal.fire({
						text: "Protocolo no válido o incompleto.",
						imageHeight: 55,
						icon: "error",
						confirmButtonText: "Ok",
					});
					break;
				default:
					MySwal.fire({
						text: "Error desconocido al generar el protocolo.",
						imageHeight: 55,
						icon: "error",
						confirmButtonText: "Ok",
					});
			}
		} catch (error) {
			console.error("Error al realizar la solicitud:", error);
			MySwal.fire({
				text: "Hubo un problema con la conexión al servidor.",
				imageHeight: 55,
				icon: "error",
				confirmButtonText: "Ok",
			});
		}
	};
	
	
	

	const abrirProtocolo = async (event, protocolo) => {
		event.preventDefault();
	
		// 👉 Abrí una ventana vacía inmediatamente
		const nuevaVentana = window.open("", "_blank");
	
		const URI_PDF_RESULTADO = `${process.env.REACT_APP_DOMINIO}${process.env.REACT_APP_PUERTO}/protocol/download/${protocolo}/v`;
	
		try {
			const response = await axios.get(URI_PDF_RESULTADO, {
				withCredentials: true,
				headers: {
					"Content-Type": "application/json",
				},
			});
	
			if (parseInt(response.data.code) === 200) {
				const base64PDF = response.data.data;
				const binaryString = atob(base64PDF);
				const byteArray = new Uint8Array(binaryString.length);
				for (let i = 0; i < binaryString.length; i++) {
					byteArray[i] = binaryString.charCodeAt(i);
				}
	
				const file = new Blob([byteArray], { type: "application/pdf" });
				const fileURL = URL.createObjectURL(file);
	
				// 👉 Ahora usá la ventana que abriste antes
				nuevaVentana.location.href = fileURL;
	
				handleRefresh();
			} else {
				nuevaVentana.close(); // si hubo error, cerrala
				throw new Error("Protocolo no disponible");
			}
		} catch (error) {
			nuevaVentana.close();
			console.error(error);
			MySwal.fire({
				text: "Hubo un problema al visualizar el protocolo.",
				icon: "error",
				confirmButtonText: "Ok",
			});
		}
	};
	
	return (
		<>
			{/* <Header /> */}
			{/*  <button
          className="boton-vehiculos-nuevo justify-content-center"
          onClick={(e) => logout(e)}
        >
          Logout
        </button> */}

			<div
				style={{
					backgroundColor: "#fff",
					borderRadius: "0.5em",
					padding: "20px",
					boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
					maxWidth: "1200px",
					minHeight: "100vh",
					margin: "1em auto",
					boxSizing: "border-box",
				}}>
				<div
					style={{
						display: "flex",
						flexWrap: "wrap",
						justifyContent: "space-between",
						alignItems: "center",
						gap: "10px",
					}}
					className="responsive-container">
					<span className="subtitle" style={{ flex: "1 1 auto" }}>
						Mis datos
					</span>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							gap: "10px",
							flexWrap: "wrap",
							alignItems: "center",
							justifyContent: "flex-end",
						}}
						className="button-group">
						<div style={{ position: "relative" }}>
							{sesion.contrasenia && (
								<Tooltip title="Contraseña insegura" placement="top">
									<span
										style={{
											position: "absolute",
											top: "-0.8em",
											right: "-0.08em",
											backgroundColor: "red",
											borderRadius: "50%",
											padding: "2px",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											zIndex: "1",
										}}>
										<ExclamationOutlined
											style={{ color: "white", fontSize: "0.8em" }}
										/>{" "}
									</span>
								</Tooltip>
							)}
							<BtnPrincipal
								texto="Cambiar contraseña"
								onClick={showModal}
								estilo={{
									backgroundColor: "transparent",
									color: "#1B70B6",
									borderRadius: "0.5em",
									border: "1px solid #1B70B6",
									position: "relative",
								}}
							/>
						</div>
						<div style={{ position: "relative" }}>
							{sesion.pre_cambio
								? (datosPreCambio.email === "" ||
										datosPreCambio.email === null) && (
										<Tooltip
											title="Para su seguridad, Ingrese un correo electronico valido"
											placement="top">
											<span
												style={{
													position: "absolute",
													top: "-0.8em",
													right: "-0.08em",
													backgroundColor: "red",
													borderRadius: "50%",
													padding: "2px",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													zIndex: "1",
												}}>
												<ExclamationOutlined
													style={{ color: "white", fontSize: "0.8em" }}
												/>
											</span>
										</Tooltip>
								  )
								: (sesion.email === "" || sesion.email === null) && (
										<Tooltip
											title="Para su seguridad, Ingrese un correo electronico valido"
											placement="top">
											<span
												style={{
													position: "absolute",
													top: "-0.8em",
													right: "-0.08em",
													backgroundColor: "red",
													borderRadius: "50%",
													padding: "2px",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													zIndex: "1",
												}}>
												<ExclamationOutlined
													style={{ color: "white", fontSize: "0.8em" }}
												/>
											</span>
										</Tooltip>
								  )}
							<BtnPrincipal
								texto={"Información Personal "}
								onClick={showModalDatos}
								estilo={{
									backgroundColor: "transparent",
									color: "#1B70B6",
									borderRadius: "0.5em",
									border: "1px solid #1B70B6",
									position: "relative",
								}}
							/>
						</div>
					</div>
				</div>{" "}
				<br></br>
				<hr></hr>
				<br></br>
				<div
					style={{ marginBottom: "20px", display: "flex", flexWrap: "wrap" }}>
					{sesion.pre_cambio
						? datosPreCambio.nombre && (
								<span style={{ marginRight: "10px" }}>
									{datosPreCambio.nombre}
								</span>
						  )
						: sesion.nombre && (
								<span style={{ marginRight: "10px" }}>{sesion.nombre}</span>
						  )}
					{sesion.pre_cambio
						? datosPreCambio.apellido && (
								<span style={{ marginRight: "10px" }}>
									{datosPreCambio.apellido}
								</span>
						  )
						: sesion.apellido && (
								<span style={{ marginRight: "10px" }}>{sesion.apellido}</span>
						  )}
				</div>
				<div
					style={{ marginBottom: "20px", display: "flex", flexWrap: "wrap" }}>
					{sesion.pre_cambio
						? datosPreCambio.email && (
								<span style={{ marginRight: "10px" }}>
									<strong className="label-datos">Correo electrónico:</strong>{" "}
									{datosPreCambio.email}
								</span>
						  )
						: sesion.email && (
								<span style={{ marginRight: "10px" }}>
									<strong className="label-datos">Correo electrónico:</strong>{" "}
									{sesion.email}
								</span>
						  )}
					{sesion.pre_cambio
						? datosPreCambio.telefono && (
								<span style={{ marginRight: "10px" }}>
									<strong className="label-datos">Teléfono:</strong>{" "}
									{datosPreCambio.telefono}
								</span>
						  )
						: sesion.telefono && (
								<span style={{ marginRight: "10px" }}>
									<strong className="label-datos">Teléfono:</strong>{" "}
									{sesion.telefono}
								</span>
						  )}
					{sesion.direccion && (
						<span style={{ marginRight: "10px" }}>
							<strong className="label-datos">Dirección:</strong>{" "}
							{sesion.direccion}
						</span>
					)}
					{sesion.pre_cambio
						? datosPreCambio.obra_social && (
								<span style={{ marginRight: "10px" }}>
									<strong className="label-datos">Obra Social:</strong>{" "}
									{datosPreCambio.obra_social}
								</span>
						  )
						: sesion.obra_social && (
								<span style={{ marginRight: "10px" }}>
									<strong className="label-datos">Obra Social:</strong>{" "}
									{sesion.obra_social}
								</span>
						  )}
				</div>
				<Modal
					title={
						<div style={{ fontSize: "20px", color: "#1B70B6" }}>
							Cambiar Contraseña
						</div>
					}
					open={isModalOpen}
					width={300}
					onOk={handleOk}
					onCancel={() => setIsModalOpen(false)}
					footer={null}>
					<FormularioPassCambio sesion={sesion} cerrarModal={setIsModalOpen} />
				</Modal>
				<Modal
					title={
						<div style={{ fontSize: "20px", color: "#1B70B6" }}>
							Información Personal
						</div>
					}
					open={isModalOpenDatos}
					width={500}
					onOk={handleOkDatos}
					onCancel={() => setIsModalOpenDatos(false)}
					footer={[]}>
					<FormularioPreCambio
						sesion={sesion}
						cerrarModal={setIsModalOpenDatos}
					/>
				</Modal>
				<span className="subtitle">Estudios realizados</span>
				<hr></hr>
				<br></br>
				<TablaCompleta
					fetchDatos={infoProcolos}
					Columns={currentColumns}
					elScroll={elScroll}
					rowKey={"protocolo"}
					sizeVariant="small"
					pagination={{ pageSize: 8 }}
				/>
			</div>

			<br></br>
		</>
	);
};
